import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
} from 'shared/types/filter-document';
import { GroupByMode, SortingMode } from 'shared/types/sorting-mode';
import { Tag } from 'shared/types/tag';

export const getDefaultFilterDocument = (tag?: Tag): FilterDocument => ({
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.Priority,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  [DocumentOrganizationKeys.Filters]: {
    [FilterOptionKeys.Tag]: { include: [tag?.id ?? ''] },
  },
});
